import React from 'react';
import Loader from '@/components/common/Loader';
import lazyWithRetry from '@/utils/lazyWithRetry';
import LazyDialog from '../LazyDialog';
import type { ConfirmationDialogContentProps } from './ConfirmationDialogContent';

const ConfirmationDialogContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "confirmation-dialog" */
      './ConfirmationDialogContent'
    ),
);

export type ConfirmationDialogProps = ConfirmationDialogContentProps & {
  isRendered?: boolean;
  open?: boolean;
};

export default function ConfirmationDialog({
  cancelLabel,
  children,
  confirmLabel,
  headerText,
  isRendered = false,
  onCancel,
  onClose,
  onConfirm,
  confirmButtonColor,
  open = false,
  ...dialogProps
}: ConfirmationDialogProps) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        isRendered={isRendered}
        onClose={onClose}
        open={open}
        classes={{ paper: 'w-full max-sm' }}
        {...dialogProps}
      >
        <ConfirmationDialogContent
          cancelLabel={cancelLabel}
          confirmLabel={confirmLabel}
          confirmButtonColor={confirmButtonColor}
          headerText={headerText}
          onCancel={onCancel}
          onClose={onClose}
          onConfirm={onConfirm}
        >
          {children}
        </ConfirmationDialogContent>
      </LazyDialog>
    </React.Suspense>
  );
}
